import { get_translations } from "workflow/utils/make_translations"
import render_string from "workflow/utils/render_string"

export default (name, ...args) =>
  get_translations("urls").then(urls => render_string(urls[name], ...args))
